<!-- Dialog Template -->
<ng-template #dialogContent>
    <div class="olcum-dialog-content">

        <!-- Header Info -->
        <div class="header-info">
            <div class="form-group compact">
                <label class="form-label">İsim</label>
                <input type="text" class="form-input" [(ngModel)]="isim" (ngModelChange)="isimDegisti()" placeholder="Ölçüm.X">
            </div>

            <div class="info-row">
                <span class="info-label">Mesafe:</span>
                <span class="info-value">{{ formatliDegerAl() }}</span>
                <span class="info-label">Tarih:</span>
                <span class="info-value">{{ tarih }}</span>
            </div>
        </div>

        <!-- Tab Navigation -->
        <div class="tab-navigation">
            <button class="tab-btn" [class.active]="aktifSekme === 'deger'" (click)="aktifSekme = 'deger'" title="Değer Ayarları">
                <i class="calculator icon"></i>
            </button>
            <button class="tab-btn" [class.active]="aktifSekme === 'gorunum'" (click)="aktifSekme = 'gorunum'" title="Görünüm">
                <i class="paint brush icon"></i>
            </button>
            <button class="tab-btn" [class.active]="aktifSekme === 'gelismis'" (click)="aktifSekme = 'gelismis'" title="Gelişmiş">
                <i class="cog icon"></i>
            </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">

            <!-- DEĞER SEKMESİ -->
            <div class="tab-pane" *ngIf="aktifSekme === 'deger'">

                <!-- Ölçüm Değeri -->
                <div class="setting-row">
                    <label>Değer</label>
                    <input type="number" [(ngModel)]="olcumDegeri" (ngModelChange)="olcumDegeriDegisti()" step="0.001">
                </div>

                <div class="setting-row">
                    <label>Birim</label>
                    <select [(ngModel)]="birim" (ngModelChange)="olcumDegeriDegisti()">
                        <option *ngFor="let b of birimler" [value]="b">{{ b }}</option>
                    </select>
                </div>

                <div class="setting-row">
                    <label>Ondalık</label>
                    <input type="range" min="0" max="6" step="1" [(ngModel)]="ondalikBasamak" (ngModelChange)="olcumDegeriDegisti()">
                    <span class="value-display">{{ ondalikBasamak }}</span>
                </div>

                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="gorunur" (ngModelChange)="gorunurlukDegisti()">
                        Görünür
                    </label>
                </div>

                <!-- Hızlı Aksiyonlar -->
                <div class="action-buttons">
                    <button class="btn-icon" [class.active]="tasimaModu" (click)="tasimaModuToggle()" title="3D'de Taşı (Sürükle)">
                        <i class="arrows alternate icon"></i>
                    </button>
                    <button class="btn-icon" (click)="odakla()" title="3D'de Odakla">
                        <i class="crosshairs icon"></i>
                    </button>
                    <button class="btn-icon" (click)="kopyala()" title="Panoya Kopyala">
                        <i class="copy icon"></i>
                    </button>
                    <button class="btn-icon btn-reset" *ngIf="tasimaModu" (click)="pozisyonuSifirla()" title="Pozisyonu Sıfırla">
                        <i class="undo icon"></i>
                    </button>
                </div>
            </div>

            <!-- GÖRÜNÜM SEKMESİ -->
            <div class="tab-pane" *ngIf="aktifSekme === 'gorunum'">

                <div class="setting-row">
                    <label>Çizgi</label>
                    <input type="color" [(ngModel)]="cizgiRengi" (ngModelChange)="cizgiRengiDegisti()">
                </div>

                <div class="setting-row">
                    <label>Ok</label>
                    <input type="color" [(ngModel)]="okRengi" (ngModelChange)="okRengiDegisti()">
                    <button class="btn-icon btn-tiny" (click)="tumRenkleriAyniYap()" title="Çizgi rengiyle aynı">
                        <i class="sync icon"></i>
                    </button>
                </div>

                <div class="setting-row">
                    <label>Metin</label>
                    <input type="color" [(ngModel)]="metinRengi" (ngModelChange)="metinRengiDegisti()">
                </div>

                <div class="setting-row">
                    <label>Arkaplan</label>
                    <input type="color" [(ngModel)]="metinArkaplanRengi" (ngModelChange)="metinArkaplanDegisti()">
                </div>

                <div class="setting-row">
                    <label>Saydamlık</label>
                    <input type="range" min="0" max="100" step="5" [(ngModel)]="metinArkaplanSaydamlik" (ngModelChange)="metinArkaplanDegisti()">
                    <span class="value-display">{{ metinArkaplanSaydamlik }}%</span>
                </div>

                <div class="setting-row">
                    <label>Metin Boy</label>
                    <input type="range" min="8" max="48" step="1" [(ngModel)]="metinBoyutu" (ngModelChange)="metinBoyutuDegisti()">
                    <span class="value-display">{{ metinBoyutu }}pt</span>
                </div>

                <div class="setting-row">
                    <label>Çizgi Kal.</label>
                    <input type="range" min="1" max="10" step="0.5" [(ngModel)]="cizgiKalinligi" (ngModelChange)="cizgiKalinligiDegisti()">
                    <span class="value-display">{{ cizgiKalinligi }}px</span>
                </div>

                <div class="setting-row">
                    <label>Ok Boy</label>
                    <input type="range" min="2" max="20" step="1" [(ngModel)]="okBoyutu" (ngModelChange)="okBoyutuDegisti()">
                    <span class="value-display">{{ okBoyutu }}</span>
                </div>

                <!-- Ok Stili -->
                <div class="ok-stili-grid">
                    <button *ngFor="let stil of okStilleri"
                            class="ok-stil-btn"
                            [class.active]="okStili === stil.value"
                            (click)="okStili = stil.value; okStiliDegisti()">
                        {{ stil.label }}
                    </button>
                </div>
            </div>

            <!-- GELİŞMİŞ SEKMESİ -->
            <div class="tab-pane" *ngIf="aktifSekme === 'gelismis'">

                <!-- Parça Görünürlükleri -->
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="cizgiGorunur" (ngModelChange)="cizgiGorunurlukDegisti()">
                        Ana Çizgi
                    </label>
                </div>

                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="okGorunur" (ngModelChange)="okGorunurlukDegisti()">
                        Oklar
                    </label>
                </div>

                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="metinGorunur" (ngModelChange)="metinGorunurlukDegisti()">
                        Metin Etiketi
                    </label>
                </div>

                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="uzatmaCizgisiGorunur" (ngModelChange)="uzatmaCizgisiGorunurlukDegisti()">
                        Uzatma Çizgileri
                    </label>
                </div>

                <!-- Efektler -->
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="golgeEfekti" (ngModelChange)="golgeEfektiDegisti()">
                        Gölge Efekti
                    </label>
                </div>

                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="glowEfekti" (ngModelChange)="glowEfektiDegisti()">
                        Glow Efekti
                    </label>
                </div>

                <div class="setting-row" *ngIf="glowEfekti">
                    <label>Glow</label>
                    <input type="range" min="1" max="20" step="1" [(ngModel)]="glowYogunluk" (ngModelChange)="glowEfektiDegisti()">
                    <span class="value-display">{{ glowYogunluk }}</span>
                </div>

                <!-- Sabit Boyut -->
                <div class="setting-row checkbox">
                    <label>
                        <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="sabitBoyutDegisti()">
                        Sabit Boyut (Zoom bağımsız)
                    </label>
                </div>

                <!-- Pozisyon Bilgileri -->
                <div class="pozisyon-bilgi">
                    <div class="pozisyon-satir">
                        <span class="pozisyon-label">P1:</span>
                        <span class="pozisyon-deger">{{ koordinatFormatla(pozisyon1.x) }}, {{ koordinatFormatla(pozisyon1.y) }}, {{ koordinatFormatla(pozisyon1.z) }}</span>
                    </div>
                    <div class="pozisyon-satir">
                        <span class="pozisyon-label">P2:</span>
                        <span class="pozisyon-deger">{{ koordinatFormatla(pozisyon2.x) }}, {{ koordinatFormatla(pozisyon2.y) }}, {{ koordinatFormatla(pozisyon2.z) }}</span>
                    </div>
                </div>

                <!-- Sıfırla -->
                <div class="setting-row">
                    <button class="btn-icon btn-reset" (click)="varsayilanaGeriDon()" title="Varsayılana Sıfırla">
                        <i class="redo icon"></i>
                    </button>
                </div>
            </div>

        </div>

        <!-- Footer Actions -->
        <div class="dialog-footer">
            <button class="btn-icon btn-primary" (click)="kaydet()" title="Tamam">
                <i class="check icon"></i>
            </button>
            <button class="btn-icon btn-secondary" (click)="iptal()" title="İptal">
                <i class="close icon"></i>
            </button>
        </div>

    </div>
</ng-template>

<!-- FikoDialogService ile kullanım -->
<ng-container *ngIf="pencere">
    <ng-container *ngTemplateOutlet="dialogContent"></ng-container>
</ng-container>
